export default __webpack_public_path__ + "static/media/rgp_pvh_nca_east_kazakh.3f23f9d6.png";